var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChecklist = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bold / List / Checklist Minimalistic"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.46447 3.96447C2 5.42893 2 7.78595 2 12.5C2 17.214 2 19.5711 3.46447 21.0355C4.92893 22.5 7.28595 22.5 12 22.5C16.714 22.5 19.0711 22.5 20.5355 21.0355C22 19.5711 22 17.214 22 12.5C22 7.78595 22 5.42893 20.5355 3.96447C19.0711 2.5 16.714 2.5 12 2.5C7.28595 2.5 4.92893 2.5 3.46447 3.96447ZM10.5431 8.01724C10.8288 7.7173 10.8172 7.24256 10.5172 6.9569C10.2173 6.67123 9.74256 6.68281 9.4569 6.98276L7.14286 9.4125L6.5431 8.78276C6.25744 8.48281 5.78271 8.47123 5.48276 8.7569C5.18281 9.04256 5.17123 9.51729 5.4569 9.81724L6.59976 11.0172C6.74131 11.1659 6.9376 11.25 7.14286 11.25C7.34812 11.25 7.5444 11.1659 7.68596 11.0172L10.5431 8.01724ZM13 8.75C12.5858 8.75 12.25 9.08579 12.25 9.5C12.25 9.91422 12.5858 10.25 13 10.25H18C18.4142 10.25 18.75 9.91422 18.75 9.5C18.75 9.08579 18.4142 8.75 18 8.75H13ZM10.5431 15.0172C10.8288 14.7173 10.8172 14.2426 10.5172 13.9569C10.2173 13.6712 9.74256 13.6828 9.4569 13.9828L7.14286 16.4125L6.5431 15.7828C6.25744 15.4828 5.78271 15.4712 5.48276 15.7569C5.18281 16.0426 5.17123 16.5173 5.4569 16.8172L6.59976 18.0172C6.74131 18.1659 6.9376 18.25 7.14286 18.25C7.34812 18.25 7.5444 18.1659 7.68596 18.0172L10.5431 15.0172ZM13 15.75C12.5858 15.75 12.25 16.0858 12.25 16.5C12.25 16.9142 12.5858 17.25 13 17.25H18C18.4142 17.25 18.75 16.9142 18.75 16.5C18.75 16.0858 18.4142 15.75 18 15.75H13Z",
    fill: "#3B82F6"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChecklist);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/checklist.76a59aa22e8ce0efdca411165fd1793a.svg";